import React from 'react';

import { AuthContext, AuthContextType } from 'providers/AuthProvider';

export const useAppAuth = () => {
  return React.useContext<AuthContextType>(AuthContext);
};
